module.exports = __webpack_public_path__ + "static/media/mobile-close.f521cf45.svg";